import {registerBlockType} from "@wordpress/blocks"
const { RichText, InspectorControls, BlockControls, AlignmentToolbar, PanelColorSettings, FontSizePicker, MediaUpload, MediaUploadCheck } = wp.blockEditor;
import { PanelBody, Icon, Button, ResponsiveWrapper, RangeControl, SelectControl, ToggleControl, TextControl, __experimentalBoxControl as BoxControl, BaseControl, FormToggle, FocalPointPicker, __experimentalInputControl as InputControl, TextareaControl} from '@wordpress/components';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
import {fontfamilylist} from "./lib/fontfamilylist.js";

const BlockEdit = (props) => {	
	const { attributes, setAttributes, clientId } = props;
	const{ uniqueid, boxColor, quoteColor, shadowColor, author, authorborderRadius, contentpaddings, content, authorColor, authorbgColor, bgColor, contentColor, bgimgrepeat, bgimgposition, bgimgsize, bgimgattch, margins, paddings, opacity, Authorfontfamily,  authorfontSize, AuthorLineHeight, AuthorFontWeight, AuthorTransform, AuthorDecoration, AuthorLetterSpacing, Contentfontfamily,  contentfontSize, ContentFontWeight, ContentLineHeight, ContentTransform, ContentDecoration, ContentLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bgType, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, hidequote, hideauthor,hidecontent, addclass, customcss}=attributes;		
	
	setAttributes({ uniqueid: 'spiceblockquote' +clientId.slice(0,8) });	
	const blockStyle = plugin.pluginpath + 'assets/images/blockquote.jpg';
		
	function setAuthor(value) {
		setAttributes({authorColor:value});
	}
	function setContent(value) {
		setAttributes({contentColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	function setquoteColor(value) {
		setAttributes({quoteColor:value});
	}
	function setOverlayColor(value) {
		setAttributes({bgOverlayColor:value});
	}

	const blockquoteclass='wp-block background-img spice-blocks-blockquote';

	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
	const blockquotefield="blockquote-field";
	let containerBg = '';
	const bgImage1 =(bgImage !=null) ? bgImage : blockStyle;
	if (bgType !== 'none' && bgType === 'image') {
		containerBg = `url(${bgImage1})`;		
	} else {
		containerBg = `url(${blockStyle})`;
	}

	let backgroundPosition = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundPosition =`${bgImagePosition.x * 100}% ${ bgImagePosition.y * 100 }%`
	}
	else
	{
		backgroundPosition = ' ';
	}

	let backgroundSize = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundSize = bgImageSize;
	}
	else
	{
		backgroundSize = 'cover';
	}

	//Image Background Attachment
	let backgroundAttachment = '';
	if(bgType === 'image' && bgImage && bgImageParallax)
	{
		backgroundAttachment='fixed';
	}
	else
	{
		backgroundAttachment='scroll';
	}	
	
	//Image Repeat
	let backgroundRepeat = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundRepeat = bgImageRepeat;
	}
	else
	{
		backgroundRepeat = 'no-repeat';
	}

	if(Contentfontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+Contentfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }
    if(Authorfontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+Authorfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }
	return(
		<Fragment>
			<script> 
				var fontfamily2=`{Contentfontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);
				
				var authorfontfamily2=`{Authorfontfamily}`;				
				var authorfontfamilyurl2 = 'https://fonts.googleapis.com/css2?family='+authorfontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var authorfontfamilylink2 = document.createElement('link');
				authorfontfamilylink2.href = authorfontfamilyurl2;
				authorfontfamilylink2.rel = "stylesheet";
				authorfontfamilylink2.type =  "text/css";	          
				document.head.appendChild(authorfontfamilylink2);
			</script>
			<style dangerouslySetInnerHTML={{
			  __html: [
			    `#${uniqueid}{
					background-color: ${bgColor};
			    }
			    #${uniqueid} .spice-blocks-blockquote{
			    	background-image: ${containerBg};
			    	background-position: ${backgroundPosition}; 
					background-size:${backgroundSize};
					background-attachment: ${backgroundAttachment};
					background-repeat: ${backgroundRepeat};
					margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};					
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					animation-delay: ${delay}ms;
				}
				 #${uniqueid} blockquote.blockquote-field{
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
				}
				#${uniqueid} .spice-blocks-blockquote blockquote .blockquote-text{
					padding: ${contentpaddings.top} ${contentpaddings.right} ${contentpaddings.bottom} ${contentpaddings.left};
				}
				#${uniqueid} .spice-blocks-blockquote blockquote{
					background-color: unset;
					position: unset;
			    }
			    #${uniqueid} .spice-blocks-blockquote i{
			    	color:${quoteColor};
			    }
			    #${uniqueid} .spice-blocks-blockquote p{
		    		color:${contentColor};
					font-size: ${contentfontSize};
					font-weight: ${ContentFontWeight};
					line-height: ${ContentLineHeight}px;
					font-family: ${Contentfontfamily};
					text-transform: ${ContentTransform};
					text-decoration: ${ContentDecoration};
					letter-spacing: ${ContentLetterSpacing}px;						
			    }
			    #${uniqueid} .spice-blocks-blockquote cite{
	    			color:${authorColor};
					font-size: ${authorfontSize};
					font-weight: ${AuthorFontWeight};
					line-height: ${AuthorLineHeight}px;
					font-family: ${Authorfontfamily};
					text-transform: ${AuthorTransform};
					text-decoration: ${AuthorDecoration};
					letter-spacing: ${AuthorLetterSpacing}px;
			    }
		    	#${uniqueid} .spice-blocks-blockquote .blockquote-field .name-field .name::before{
		    		background-color:${authorColor};
		    	}
		    	${customcss}`
			    ].join('\n')
			  }}>
			</style>
			<InspectorControls>				

				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>

					<ToggleControl
						label={__('Enable/Disable Quote','spice-blocks')}
						checked={hidequote}
						onChange={(newval) => setAttributes({ hidequote: newval })}
					/>

					<ToggleControl
						label={__('Enable/Disable Content','spice-blocks')}
						checked={hidecontent}
						onChange={(newval) => setAttributes({ hidecontent: newval })}
					/>

					<ToggleControl
						label={__('Enable/Disable Author','spice-blocks')}
						checked={hideauthor}
						onChange={(newval) => setAttributes({ hideauthor: newval })}
					/>

					<BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>

		      		<BoxControl
						values={paddings}
						label={__('Box Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>					

					<BoxControl
						values={contentpaddings}
						label={__('Content Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>	setAttributes({
													...contentpaddings,
													contentpaddings: {
														top: newValue.top,
														left: newValue.left,
														right: newValue.right,
														bottom: newValue.bottom,
													},
												})
						}
					/>	
					
					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Enable/Disable on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>

					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
				            ] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
				        { animation != '' && (
				        	<>
					        	<SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
						    )
				    	}
					</PanelBody>

				</PanelBody>

				<PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							onChange: setShadowColor,
							label: __('Box Shadow:','spice-blocks')
							},
						]}
					/>
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Color & Background Settings','spice-blocks')}>
					<PanelColorSettings className={'spice-block-section-bg-color'}
						colorSettings={[
							{
								value: quoteColor,
								onChange: setquoteColor,
								clearable: true,
								label: __('Quote Color','spice-blocks')
							},
							{
								value: contentColor,
								onChange: setContent,
								clearable: true,
								label: __('Content Color','spice-blocks')
							},
							{
								value: authorColor,
								onChange: setAuthor,
								clearable: true,
								label: __('Author Color','spice-blocks')
							},
							{
								value: bgColor,
								onChange: setBgColor,
								clearable: true,
								label: __('Background Color','spice-blocks')
							},
						]}
					/>
					<div className="spice_block_section_flex_panel">
						<p className="spice_block_section_panel_label">
							{__('Background Image', 'spice-blocks')}
						</p>
						<div className="spice_block_section_panel">
							
							<Button
								isSmall={true}
								isPressed={bgType === 'image'}
								onClick={() =>
									setAttributes({
										bgType: 'image',
									})
								}
							>
								<svg width="18" height="15" viewBox="0 0 18 15">
									<path
										d="M16.083.263h-14.446c-.798 0-1.445.648-1.445 1.447v11.579c0 .8.646 1.447 1.445 1.447h14.446c.798 0 1.445-.648 1.445-1.447v-11.579c0-.8-.646-1.447-1.445-1.447zm-4.334 2.171c2.389 0 2.386 3.618 0 3.618-2.385 0-2.39-3.618 0-3.618zm-9.39 10.855l4.334-5.789 2.965 3.961 2.091-2.514 3.611 4.342h-13.001z"
										className="svg-fill"
										fillRule="nonzero"
									></path>
								</svg>
							</Button>
							
							<Button
								isSmall={true}
								onClick={() =>setAttributes({
												bgType: 'none',
											})
							}>
								<span className="dashicons dashicons-image-rotate"></span>
							</Button>
						</div>
					</div>
					{/* Image Background */}
					{bgType === 'image' && (
					    <Fragment>
					        {bgImage ? (
					            <Fragment>
					                <div className="spice_block_section_preview_container">
					                    <div className="spice_block_section_preview_image">
					                        <FocalPointPicker
					                            url={bgImage}
					                            value={bgImagePosition}
					                            onChange={(focalPoint) =>setAttributes({
										                                    bgImagePosition:
										                                    focalPoint,
										                                })
					                            }
					                        />
					                    </div>
					                    <div className="spice_block_section_preview_actions">
					                        <button
					                            onClick={() =>
					                                setAttributes({
					                                    bgImage: '',
					                                })
					                            }
					                        >
					                            <span className="dashicons dashicons-trash"></span>
					                        </button>
					                    </div>
				               		</div>
	            				</Fragment>
						        ) : (
						            <MediaUpload
						                onSelect={(media) =>setAttributes({
										                        bgImage: media.url,
										                    })
						                }
						                type="image"
						                value={bgImage}
						                render={({ open }) => (
						                    <button
						                        className="spice_block_section_custom_upload"
						                        onClick={open}
						                    >
						                        <span className="dashicons dashicons-insert"></span>
						                        <span className="spice_block_section_upload_label">
						                            {__('Add Image', 'spice-blocks')}
						                        </span>
						                    </button>
						                )}
						            />
						        )
						    }
					        <div className="spice_block_section_flex_panel">
								<p className="spice_block_section_panel_label">
									{__('Enable/Disable Parallax','spice-blocks')}
								</p>
								<FormToggle
									checked={bgImageParallax}
									onChange={() =>
										setAttributes({
											bgImageParallax: !bgImageParallax,
										})
									}
								/>
							</div>
					        <SelectControl
								label={__('Background Size', 'spice-blocks')}
								options={[
									{
										label: __('Default', 'spice-blocks'),
										value: 'initial',
									},
									{
										label: __('Cover', 'spice-blocks'),
										value: 'cover',
									},
									{
										label: __('Contain', 'spice-blocks'),
										value: 'contain',
									},
									{
										label: __('Auto', 'spice-blocks'),
										value: 'auto',
									},
								]}
								onChange={(size) => {
									setAttributes({ bgImageSize: size });
								}}
								value={bgImageSize}
							/>
							<SelectControl
								label={__('Background Repeat', 'spice-blocks')}
								options={[
									{
										label: __('No Repeat', 'spice-blocks'),
										value: 'no-repeat',
									},
									{
										label: __('Repeat', 'spice-blocks'),
										value: 'repeat',
									},
									{
										label: __('Repeat X', 'spice-blocks'),
										value: 'repeat-x',
									},
									{
										label: __('Repeat Y', 'spice-blocks'),
										value: 'repeat-y',
									},
								]}
								onChange={(value) => {
									setAttributes({ bgImageRepeat: value });
								}}
								value={bgImageRepeat}
							/>
    					</Fragment>
					)}
				</PanelBody>
				<PanelBody title={__('Background Overlay','spice-blocks')} initialOpen={false}>
					<div className="spice_block_section_flex_panel">
						<p className="spice_block_section_panel_label">
							{__('Enable/Disable Overlay','spice-blocks')}
						</p>
						<FormToggle
							checked={bgImageOverlay}
							onChange={() =>
								setAttributes({
									bgImageOverlay: !bgImageOverlay,
								})
							}
						/>
					</div>
					{bgImageOverlay && (
						<Fragment>
							
							<PanelColorSettings  initialOpen={open}
								className={'sb-color-style'}
								title={ __('Overlay Color','spice-blocks') }
								colorSettings={[
									{
									value: bgOverlayColor,
									onChange: setOverlayColor,
									label: __('Overlay Color:','spice-blocks')
									},
								]}
							/>												
							<RangeControl
								label={__('Overlay Opacity','spice-blocks')}
								value={bgOverlayOpacity}
								onChange={(value) =>setAttributes({
														bgOverlayOpacity: value,
													})
								}
								min={0.1}
								max={1}
								step={0.01}
							/>
						</Fragment>
					)}
				</PanelBody>
				<PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')}>					    

		        	<PanelBody initialOpen={false} title={__('Content Font Typography','spice-blocks')}>    
		        		<SelectControl
				            label={__(' Font Family','spice-blocks')}
				            value={ Contentfontfamily }
				            options={fontfamilylist}
				            onChange={ (newtext) => setAttributes({ Contentfontfamily: newtext }) }
				        />		        		
			        	<FontSizePicker 
			        		__nextHasNoMarginBottom
				            value={ contentfontSize }
				            onChange={(userVal) => setAttributes({
														contentfontSize: userVal
													})
							}
			        	/>
			        	<SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ ContentFontWeight }
				            options={ [
				                { label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
				            ] }
				            onChange={ (newtext) => setAttributes({ ContentFontWeight: newtext }) }
				        />
				        <RangeControl 
								label={__('line Height(px)','spice-blocks')}		    
						    	value={ ContentLineHeight}
				        		onChange={(newtext) => setAttributes({ ContentLineHeight: newtext })}
									min={0}
									max={100}
						/>
						<SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ ContentTransform }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
				            ] }
				            onChange={ (newtext) => setAttributes({ ContentTransform: newtext }) }					  
			        	/>

				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ ContentDecoration }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Underline','spice-blocks'), value: 'underline' },
				                { label: __('Overline','spice-blocks'), value: 'overline' },
				                { label: __('Line Through','spice-blocks'), value: 'line-through' },
				            ] }
				            onChange={ (newtext) => setAttributes({ ContentDecoration: newtext }) }					  
				        />

				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ ContentLetterSpacing}
				        	onChange={(newtext) => setAttributes({ ContentLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>

		        	</PanelBody>

		        	<PanelBody initialOpen={false} title={__('Author Font Typography','spice-blocks')}>
				        <SelectControl
				            label={__(' Font Family','spice-blocks')}
				            value={ Authorfontfamily }
				            options={fontfamilylist}
				            onChange={ (newtext) => setAttributes({ Authorfontfamily: newtext }) }
				        />				     
				        <FontSizePicker 
				        	__nextHasNoMarginBottom
				            value={ authorfontSize }
				            onChange={(val) => setAttributes({
													authorfontSize: val
												})
							}
				        />
				        <SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ AuthorFontWeight }
				            options={ [
				                { label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
				            ] }
				            onChange={ (val) => setAttributes({ AuthorFontWeight: val }) }					  
				        />
				        <RangeControl 
							label={__('line Height(px)','spice-blocks')}			    
						    value={ AuthorLineHeight}
				        	onChange={(val) => setAttributes({ AuthorLineHeight: val })}
								min={0}
								max={100}
						/>				        
				        <SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ AuthorTransform }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
				            ] }
				            onChange={ (newtext) => setAttributes({ AuthorTransform: newtext }) }					  
			        	/>
				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ AuthorDecoration }
				            options={ [
				                { label: 'Default', value: '' },
				                { label: 'Underline', value: 'underline' },
				                { label: 'Overline', value: 'overline' },
				                { label: 'Line Through', value: 'line-through' },
				            ] }
				            onChange={ (newtext) => setAttributes({ AuthorDecoration: newtext }) }					  
				        />
				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ AuthorLetterSpacing}
				        	onChange={(newtext) => setAttributes({ AuthorLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>
					</PanelBody>

		    	</PanelBody>

		    	<PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>					

			</InspectorControls>

			<BlockControls>
					<AlignmentToolbar
						value={attributes.textAlignment}
						onChange={(newalign) => setAttributes({ textAlignment: newalign })}
					/>
			</BlockControls>
			<div class="spice-blockquote" id={uniqueid}>
				<figure className={`${blockquoteclass} ${alignmentClass} ${animationclass} ${displayclass} ${addclass}`}  >

					{ bgImageOverlay && (
						<div className={"spice-blocks-overlay"} style={{
								backgroundColor: bgImageOverlay
									? bgOverlayColor
									: '',
								opacity: bgImageOverlay ? bgOverlayOpacity : '',
							}}>
						</div>
					)}   
					
			        <blockquote class={`${blockquotefield} ${alignmentClass}`} >
			            <div class="blockquote-text">
			              {hidequote && ( <span class="quote-icon"><i class="fa-solid fa-quote-right"></i></span> )}
			              { hidecontent && (
				              	<RichText
									key="editable"
									tagName="p"
									value={content}
									onChange={(newvalue) => setAttributes({ content: newvalue })}					
								/>
								)
						}
			            </div>
			            { hideauthor && (
				            <div class="name-field">
				          		<RichText
									key="editable"
									className="name"
									tagName="cite"
									value={author}
									onChange={(newvalue) => setAttributes({ author: newvalue })}
								/>
				            </div>
				           	)
				        }	                
			        </blockquote>
	 			</figure>
 			</div>									
		</Fragment>
	);
};
 

registerBlockType('spice-blocks/spice-blockquote',{

	title:__('Blockquote','spice-blocks'),
	icon: <svg width="24.000000000000004" height="24.000000000000004" xmlns="http://www.w3.org/2000/svg" version="1.1" aria-hidden="true" focusable="false"><g><path stroke="#09A223" id="svg_21" d="m0.48982,3.10824l0,0c0,-1.41994 1.18096,-2.57103 2.63775,-2.57103l1.19898,0l0,0l5.75509,0l10.7908,0c0.69958,0 1.3705,0.27088 1.86517,0.75304c0.49467,0.48216 0.77258,1.13611 0.77258,1.81799l0,6.42758l0,0l0,3.85655l0,0c0,1.41994 -1.18096,2.57103 -2.63775,2.57103l-10.7908,0l-7.51832,6.53754l1.76323,-6.53754l-1.19898,0c-1.45679,0 -2.63775,-1.15109 -2.63775,-2.57103l0,0l0,-3.85655l0,0l0,-6.42758z" fill="#09A223"></path><g stroke="null" id="svg_1"><g stroke="null" id="right_x5F_quote"><g stroke="null" id="svg_2"><path stroke="null" id="svg_3" fill="#fff" d="m6.80436,4.15632l0,3.89673l2.59782,0c0,1.43205 -1.16447,2.59782 -2.59782,2.59782l0,1.29891c2.14872,0 3.89673,-1.74801 3.89673,-3.89673l0,-3.89673l-3.89673,0z"></path><path stroke="null" id="svg_4" fill="#fff" d="m13.29891,4.15632l0,3.89673l2.59782,0c0,1.43205 -1.16447,2.59782 -2.59782,2.59782l0,1.29891c2.14872,0 3.89673,-1.74801 3.89673,-3.89673l0,-3.89673l-3.89673,0z"></path></g></g></g></g></svg>,
	example: {
      'attributes' : {
          'mode' : 'preview',
      }
  	},
	category:'spice-blocks',
	keywords:['Spice Blockquote','blockquote', 'spice'],
	attributes:{
		uniqueid:{
			type:'string',
		},
		hidequote:{
			type:'boolean',
			default:true,
		},
		hidecontent:{
			type:'boolean',
			default:true,
		},
		hideauthor:{
			type:'boolean',
			default:true,
		},
		author:{
			type:'string',
			default:'Cillum Dolore'
		},
		content:{
			type:'string',
			default:' sure there is not anything embarrassing hidden in the middle of text.'
		},
		textAlignment: {
			type: 'string',
			default:'center'
		},
		authorColor:{
			type:'string',
			default:'#fff'
		},
		bgColor:{
	    	type:'string',
	    	default:'transparent',
    	},
		contentColor:{
			type:'string',
			default:'#fff'
		},
		shadowColor:{
			type:'string',
			default:'#000'
		},
		quoteColor:{
			type:'string',
		},
		 
		bgType: {
			type: 'string',
			default: 'none'
		},
		bgImage: {
			type: 'string',
		},
		bgImageParallax: {
			type: 'boolean',
			default: false
		},
		bgImageSize: {
			type: 'string',
			default: 'cover'
		},
		bgImageRepeat: {
			type: 'string',
			default: 'no-repeat'
		},
		bgImageOverlay: {
			type: 'boolean',
			default: false
		},
		bgOverlayColor: {
			type: 'string',
			default: '#000000'
		},
		bgOverlayOpacity: {
			type: "number",
			default: 0.7
		},
		bgImagePosition: {
			type: 'object',
			default: {
				"x": 0.5,
				"y": 0.5
			}
		},
		margins: {
			type: 'object',
			default: {
				top: '0px',
				left: '0px',
				right: '0px',
				bottom: '0px'
			}
		},
		paddings:{
			type: 'object',
			default: {
				top: '223px',
				left: '0px',
				right: '0px',
				bottom: '223px',
			},
		},
		contentpaddings:{
			type: 'object',
		    default: {
			      top: '0px',
			      left: '0px',
			      right: '0px',
			      bottom: '0px',
		    },
		},
		opacity:{
			type:'number',
			default:0.5
		},
		hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
	  	hidedesktop:{
    		type: 'boolean',
			default: true
    	},
    	hidetablet:{
    		type: 'boolean',
			default: true
    	},
    	hidemobile:{
    		type: 'boolean',
			default: true
   		},
    	animation:{
	    	type:'string',
	    	default:''
    	},
    	durations:{
	    	type:'string',
	    	default:''
    	},
	    delay:{
	    	type:'string',
	    },
	    Contentfontfamily:{
	    	type:'string',
	    	default:'Open Sans'
	    }, 
    	contentfontSize:{
			type:'string',
			default:'30px'
		},
		ContentFontWeight:{
			type:'string',
			default:'600'
		},
		ContentLineHeight:{
	    	type:'number',
	    	default:50
   		},
		ContentTransform:{
    		type:'string'
    	},
    	ContentDecoration:{
    		type:'string'
    	},
    	ContentLetterSpacing:{
    		type:'number'
    	},
   		Authorfontfamily:{
	    	type:'string',
	    	default:'Open Sans'
    	}, 
    	authorfontSize:{
			type:'string',
			default:'24px'
		},
		AuthorFontWeight:{
			type:'string',
			default:'400'
		},	
    	AuthorLineHeight:{
	    	type:'number',
	    	default:50
    	},
	    AuthorTransform:{
	    	type:'string'
	    },
	    AuthorDecoration:{
	    	type:'string'
	    },
	    AuthorLetterSpacing:{
	    	type:'number'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
	},

	edit:BlockEdit,

	save:(props)=>{
		const { attributes } = props;
		const{ uniqueid, boxColor, quoteColor, shadowColor, author, authorborderRadius, contentpaddings, content, authorColor, authorbgColor, bgColor, contentColor, bgimgrepeat, bgimgposition, bgimgsize, bgimgattch, margins, paddings, opacity, Authorfontfamily,  authorfontSize, AuthorLineHeight, AuthorFontWeight, AuthorTransform, AuthorDecoration, AuthorLetterSpacing, Contentfontfamily,  contentfontSize, ContentFontWeight, ContentLineHeight, ContentTransform, ContentDecoration, ContentLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bgType, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, hidequote, hideauthor,hidecontent, addclass, customcss}=attributes;
		const blockStyle = plugin.pluginpath + 'assets/images/blockquote.jpg';
		const blockquoteclass='wp-block background-img spice-blocks-blockquote';

		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
		const blockquotefield="blockquote-field";
		let containerBg = '';

		if (bgType !== 'none' && bgType === 'image') {
			containerBg = `url(${bgImage})`;		
		} else {
			containerBg = `url(${blockStyle})`;
		}

		let backgroundPosition = '';
		if(bgType === 'image' && bgImage)
		{
			backgroundPosition =`${bgImagePosition.x * 100}% ${ bgImagePosition.y * 100 }%`
		}
		else
		{
			backgroundPosition = '';
		}

		let backgroundSize = '';
		if(bgType === 'image' && bgImage)
		{
			backgroundSize = bgImageSize;
		}
		else
		{
			backgroundSize = 'cover';
		}

		//Image Background Attachment
		let backgroundAttachment = '';
		if(bgType === 'image' && bgImage && bgImageParallax)
		{
			backgroundAttachment='fixed';
		}
		else
		{
			backgroundAttachment='scroll';
		}	
		
		//Background Image Repeat
		let backgroundRepeat = '';
		if(bgType === 'image' && bgImage)
		{
			backgroundRepeat = bgImageRepeat;
		}
		else
		{
			backgroundRepeat = 'no-repeat';
		}

		return(
			<>
			<style dangerouslySetInnerHTML={{
			  __html: [
			    `#${uniqueid}{
					background-color: ${bgColor};
			    }
			    #${uniqueid} .spice-blocks-blockquote{
			    	background-image: ${containerBg};
			    	background-position: ${backgroundPosition}; 
					background-size:${backgroundSize};
					background-attachment: ${backgroundAttachment};
					background-repeat: ${backgroundRepeat};
					margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};					
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					animation-delay: ${delay}ms;
				}
				 #${uniqueid} blockquote.blockquote-field{
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
				}
				#${uniqueid} .spice-blocks-blockquote blockquote .blockquote-text{
					padding: ${contentpaddings.top} ${contentpaddings.right} ${contentpaddings.bottom} ${contentpaddings.left};
				}
				#${uniqueid} .spice-blocks-blockquote blockquote{
					background-color: unset;
					position: unset;
			    }
			    #${uniqueid} .spice-blocks-blockquote i{
			    	color:${quoteColor};
			    }
			    #${uniqueid} .spice-blocks-blockquote p{
		    		color:${contentColor};
					font-size: ${contentfontSize};
					font-weight: ${ContentFontWeight};
					line-height: ${ContentLineHeight}px;
					font-family: ${Contentfontfamily};
					text-transform: ${ContentTransform};
					text-decoration: ${ContentDecoration};
					letter-spacing: ${ContentLetterSpacing}px;						
			    }
			    #${uniqueid} .spice-blocks-blockquote cite{
	    			color:${authorColor};
					font-size: ${authorfontSize};
					font-weight: ${AuthorFontWeight};
					line-height: ${AuthorLineHeight}px;
					font-family: ${Authorfontfamily};
					text-transform: ${AuthorTransform};
					text-decoration: ${AuthorDecoration};
					letter-spacing: ${AuthorLetterSpacing}px;
			    }
		    	#${uniqueid} .spice-blocks-blockquote .blockquote-field .name-field .name::before{
		    		background-color:${authorColor};
		    	}
		    	${customcss}`
			    ].join('\n')
			  }}>
			</style>
			<script> 
				var fontfamily2=`{Contentfontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);
				
				var authorfontfamily2=`{Authorfontfamily}`;				
				var authorfontfamilyurl2 = 'https://fonts.googleapis.com/css2?family='+authorfontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var authorfontfamilylink2 = document.createElement('link');
				authorfontfamilylink2.href = authorfontfamilyurl2;
				authorfontfamilylink2.rel = "stylesheet";
				authorfontfamilylink2.type =  "text/css";	          
				document.head.appendChild(authorfontfamilylink2);
			</script>

			<div class="spice-blockquote" id={uniqueid}>
				<figure className={`${blockquoteclass} ${alignmentClass} ${animationclass} ${displayclass} ${props.attributes.className} ${addclass}`} >
					{ bgImageOverlay && (
						<div className={"spice-blocks-overlay"} style={{
								backgroundColor: bgImageOverlay
									? bgOverlayColor
									: '',
								opacity: bgImageOverlay ? bgOverlayOpacity : '',
							}}>
						</div>
					)}     
	        		<blockquote class={`${blockquotefield} ${alignmentClass}`}>
			            <div class="blockquote-text">
			            	{ hidequote && (
				              	<span class="quote-icon">
				              		<i class="fa-solid fa-quote-right"></i>
				              	</span>
				              	)
				            }
				            { hidecontent && (
			              		<RichText.Content
									tagName="p"
									value={content}
								/>
								)
							}
			            </div>
			            { hideauthor && (			            
				            <div class="name-field">
				          		<RichText.Content
									className="name"
									tagName="cite"
									value={author}
								/>
		        			</div>
		        			)
		        		}	                
	    			</blockquote>
				</figure>
			</div>						
		</>
		)
	}
})